import { useState } from 'react';
import { useRouter } from 'next/navigation';

export function useSafeNavigation() {
    const router = useRouter();
    const [isNavigating, setIsNavigating] = useState(false);

    const safePush = async (href: string) => {
        if (isNavigating) return;
        setIsNavigating(true);
        await router.push(href);
        setIsNavigating(false);
    };

    const safeReplace = async (href: string) => {
        if (isNavigating) return;
        setIsNavigating(true);
        await router.replace(href);
        setIsNavigating(false);
    };

    return { safePush, safeReplace, isNavigating };
}
